// ** React Imports
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// ** Styles Imports
import Styles from './kycReminderModal.module.css'

// ** Assets Imports
import kycVerifyIcon from '../../../assets/icons/imported/kyc-verify.svg'
import kycPendingIcon from '../../../assets/icons/imported/kyc-warning.svg'
import kycRejectedIcon from '../../../assets/icons/imported/kyc-danger.svg'

// ** Redux Imports
import { useSelector } from 'react-redux'

// ** Helpers Imports
import { closeKYCReminderModal } from './helpers'

// ** Components Imports
import Button from '../../../components/Button/Button'
import WenbitModal from '../../../components/Modal/Modal'

function KYCReminderModal() {
  // ** Hooks
  const navigate = useNavigate()

  // ** States
  const [modalType, setModalType] = useState('required')
  const modalOpen = useSelector(state => state.kycReminderModalState.open)
  const userData = useSelector(state => state.userData.value)

  useEffect(() => {
    if (!userData?.labels) return

    const documentStatus = userData.labels.find(el => el.key === 'document')?.value

    if (documentStatus === 'pending' || documentStatus === 'in_progress') {
      setModalType('pending')
    } else if (documentStatus === 'rejected') {
      setModalType('rejected')
    } else {
      setModalType('required')
    }
  }, [userData])

  // ** Handlers
  const handleKYCRedirect = () => {
    closeKYCReminderModal()
    navigate('/kyc')
  }

  const getModalMessage = () => {
    switch (modalType) {
      case 'required':
        return "Please complete the KYC verification process before proceeding with deposit, withdraw or convert. It's mandatory for security and compliance purposes."
      case 'rejected':
        return 'Your KYC has been rejected. Please try again later'
      case 'pending':
        return "Your KYC verification is in progress. We will notify you once it's completed."
      default:
        return ''
    }
  }

  const getModalIcon = () => {
    switch (modalType) {
      case 'rejected':
        return kycRejectedIcon
      case 'pending':
        return kycPendingIcon
      default:
        return kycVerifyIcon
    }
  }

  return (
    <WenbitModal
      open={modalType && modalOpen}
      showCloseButton={true}
      modalWidth={370}
      onClose={closeKYCReminderModal}
      lineHeaderColor='var(--warning-color)'
      render={() => (
        <div className={Styles.bodyContainer}>
          <img src={getModalIcon()} width={150} alt='KYC status icon' />
          <h3>
            {modalType === 'required'
              ? userData?.phones?.length === 0
                ? 'Verify your KYC'
                : 'Continue your KYC'
              : modalType === 'rejected'
              ? 'Your KYC was Rejected'
              : 'Awaiting KYC Response'}
          </h3>
          <p>{getModalMessage()}</p>
          {modalType === 'required' && (
            <Button
              onClick={handleKYCRedirect}
              text={userData?.phones?.length === 0 ? 'Verify your KYC' : 'Continue'}
            />
          )}
        </div>
      )}
    />
  )
}

export default KYCReminderModal
